import React, { useState } from "react";
import InputSearch from "../../../AddOSP/Component/Search/InputSearch";

const ExecutivesDetails = () => {
  const [showModal, setShowModal] = useState(false);
  
  const handleViewVariants = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
      <div className="flex justify-between pb-3 border-b items-center mb-4">
        <h2 className="text-base font-semibold text-[#333333]">Executives Details</h2>
        <button
          onClick={handleViewVariants}
          className="flex items-center gap-1 bg-[#0099E5] hover:bg-[#007FCC] text-white text-sm px-3 py-1.5 rounded"
        >
          <span className="bg-white text-[#0099E5] rounded-full w-5 h-5 flex items-center justify-center text-xs font-semibold">2</span>
          View Variants
        </button>
      </div>

      <table className="w-full">
        <tbody>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Name:</td>
            <td className="p-3 text-sm text-[#333333]">LBINXXXXX</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Designation:</td>
            <td className="p-3 text-sm text-[#333333]">Emayam Technology</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Organizational Hierarchy:</td>
            <td className="p-3 text-sm text-[#333333]">Owner</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Email ID:</td>
            <td className="p-3 text-sm text-[#333333]">Manufacture</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Primary Contact Number:</td>
            <td className="p-3 text-sm text-[#333333]">+91 6381998365</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Additional Contact Number:</td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Preferred Instant Message-1:</td>
            <td className="p-3 text-sm text-[#333333]">Owner</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Preferred Instant Message-1 ID:</td>
            <td className="p-3 text-sm text-[#333333]">Manufacture</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Preferred Instant Message -2:</td>
            <td className="p-3 text-sm text-[#333333]">Owner</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Preferred Instant Message-2 ID:</td>
            <td className="p-3 text-sm text-[#333333]">Manufacture</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">Personal LinkedIn URL:</td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      {/* Popup */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg py-7 px-7 w-[90%] md:w-1/2 max-h-[70vh] overflow-y-auto ">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Geo Details Variants</h3>
              <InputSearch />
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <hr className="mb-4" />
            <h3 className="text-lg font-semibold underline underline-offset-4 mb-4">Executive Details 1:</h3>

            {/* Single Column Table */}
            <table className="w-full">
              <tbody className="space-y-2">
                {[
                  ["Name", "LBINXXXXX"],
                  ["Designation", "Emayam Technology"],
                  ["Organizational Hierarchy", "Owner"],
                  ["Email ID", "Manufacture"],
                  ["Primary Contact Number", "+91 6381998365"],
                  ["Additional Contact Number", "...................."],
                  ["Preferred Instant Message-1", "Owner"],
                  ["Preferred Instant Message-1 ID", "Manufacture"],
                  ["Preferred Instant Message-2", "Owner"],
                  ["Preferred Instant Message-2 ID", "Manufacture"],
                  ["Personal LinkedIn URL", "...................."],
                ].map(([label, value], index) => (
                  <tr key={index} className="">
                    <td className="p-2 font-medium text-sm text-[#333333]">{label}</td>
                    <td className="p-2 text-sm text-[#333333]">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
             <h3 className="text-lg font-semibold underline underline-offset-4 mb-4">Executive Details 2:</h3>
            <table className="w-full">
              <tbody className="space-y-2">
                {[
                  ["Name", "LBINXXXXX"],
                  ["Designation", "Emayam Technology"],
                  ["Organizational Hierarchy", "Owner"],
                  ["Email ID", "Manufacture"],
                  ["Primary Contact Number", "+91 6381998365"],
                  ["Additional Contact Number", "...................."],
                  ["Preferred Instant Message-1", "Owner"],
                  ["Preferred Instant Message-1 ID", "Manufacture"],
                  ["Preferred Instant Message-2", "Owner"],
                  ["Preferred Instant Message-2 ID", "Manufacture"],
                  ["Personal LinkedIn URL", "...................."],
                ].map(([label, value], index) => (
                  <tr key={index} className="">
                    <td className="p-2 font-medium text-sm text-[#333333]">{label}</td>
                    <td className="p-2 text-sm text-[#333333]">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="bg-[#0099E5] hover:bg-[#007FCC] text-white px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExecutivesDetails;